import { useCurrentAddressInfo } from '@/hooks';
import { request } from '@/utils';
import { useQuery } from 'react-query';

type RecommendUser = GeneralAccount & { article_count: number };

export type RecommendUserRes = { users: RecommendUser[] };

export const useRecommendUsers = () => {
  const url = '/feed_trend/recommend_users';
  const { address } = useCurrentAddressInfo();
  return useQuery([url, address], () => request.get<RecommendUserRes>(url, { limit: 10 }), {
    select: res => res?.users,
  });
};
